import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { updateTruckAction } from "../../../modules/truckline/action";
import { validForm } from "../../FormElement/FormValidator";
import TrucklineForm from "./TrucklineForm";

class EditTruckline extends Component {
  state = {
    trucklineInfo: {
      farmId: userFarmDetail().id || this.props.MainFarmId,
      name: "",
      truckLineTypeId: "",
      contact: "",
      address: "",
      comment: ""
    },
    formErrors: {
      name: "",
      truckLineTypeId: "",
      contact: "",
      address: "",
      comment: ""
    },
    isValid: true,
    successMessage: false,
    errorMessage: {},
    edited: false
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentWillMount() {
    const {
      id,
      name,
      truckLineTypeEntity = {},
      contact,
      address,
      comment
    } = this.props.selectedTruck;
    this.setState({
      trucklineInfo: {
        id,
        name,
        truckLineTypeId: truckLineTypeEntity.id,
        contact,
        address,
        comment
      }
    });
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "contact") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "address" || name === "comment") {
      if (value.match(/^(.|\n){0,256}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          trucklineInfo: {
            ...prevState.trucklineInfo,
            [name]: value
          }
        };
      },
      () => {
        const { trucklineInfo } = this.state;
        const requiredFied = { ...trucklineInfo };
        delete requiredFied.comment;
        delete requiredFied.address;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFied)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { trucklineInfo } = this.state;
        const requiredFied = { ...trucklineInfo };
        delete requiredFied.comment;
        delete requiredFied.address;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFied)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.truckUpdated && nextProps.truckUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  updateTruckline = e => {
    e.preventDefault();
    const { trucklineInfo, isValid } = this.state;
    this.setState({ isValid: true, edited: false });
    (trucklineInfo.farmId = userFarmDetail().id || this.props.MainFarmId),
      this.props.updateTruckAction(trucklineInfo);
  };
  render() {
    const { successMessage, isValid, trucklineInfo, edited } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/trucklines" />;
    }
    return (
      <TrucklineForm
        formLabel="Edit truckline"
        buttonLabel="Update"
        trucklineInfo={trucklineInfo}
        handleChange={this.handleChange}
        //handleError={this.handleError}
        createTruckline={this.updateTruckline}
        isValid={isValid}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedTruck: state.trucklineReducer.selectedTruck,
    truckUpdated: state.trucklineReducer.truckUpdated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateTruckAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTruckline);



// WEBPACK FOOTER //
// ./src/components/private/Trucklines/EditTruckline.js